import { render, staticRenderFns } from "./CheckDetail.vue?vue&type=template&id=6c6347db&scoped=true"
import script from "./CheckDetail.vue?vue&type=script&lang=js"
export * from "./CheckDetail.vue?vue&type=script&lang=js"
import style0 from "./CheckDetail.vue?vue&type=style&index=0&id=6c6347db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6347db",
  null
  
)

export default component.exports